import { render, staticRenderFns } from "./SdNumber.vue?vue&type=template&id=b9f54c4c&scoped=true"
import script from "./SdNumber.vue?vue&type=script&lang=js"
export * from "./SdNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f54c4c",
  null
  
)

export default component.exports